import React, { Component } from 'react';
import styled from 'styled-components';

export default class LeftMenuButton extends Component {
  constructor(props) {
    super(props);

    this.onBack = this.onBack.bind(this);
    this.onClick = this.onClick.bind(this);

    this.state = {
      open: false,
      displayText: false,
      display: false,
    };
  }

  onBack() {
    this.onClick(null, () => {
      this.props.onClick();
    });
  }

  onCancel() {
    const confirmed = confirm('Are you sure you want to go cancel your registration?');
    if (confirmed) window.location.replace(`/signup-welcome`);
  }

  onClick(e, cb) {
    const newOpen = !this.state.open;
    const newDisplayText = !this.state.displayText;
    const newDisplayValue = !this.state.display;

    let display = this.state.display;
    if (newDisplayValue) {
      display = newDisplayValue;
    } else {
      setTimeout(() => {
        this.setState({ display: false })
      }, 500);
    }

    this.setState({
      open: newOpen,
      display,
    }, () => {
      const delay = newDisplayText ? 200 : 0;
      
      setTimeout(() => {
        this.setState({
          displayText: newDisplayText,
        }, cb ? cb : () => {});
      }, delay);
    });
  }

  render() {
    const iconImage = this.state.open
      ? '/images/redesign/navbar/close.png'
      : '/images/redesign/navbar/menu.png';
    
    const backImage = '/images/redesign/navbar/back.png';
    const backText = '/images/redesign/navbar/go-back.png';
    const cancelImage = '/images/redesign/navbar/cancel.png';
    const cancelText = '/images/redesign/navbar/cancel-registration.png';

    return (
      <div style={{ overflow: 'hidden' }}>
        <div
          style={{
            height: 2000,
            width: 2000,
            position: 'absolute',
            zIndex: 1,
            left: -500,
            top: -500,
            display: this.state.open ? 'block' : 'none',
          }}
          onClick={this.onClick}
        />
        <div style={{
          backgroundColor: 'none',
          width: 75,
          height: 75,
          transition: 'all 300ms ease-in-out',
          position: 'relative',
          zIndex: 5,
        }} onClick={this.onClick}>
          <Image src={iconImage} />
        </div>
        { this.props.currentActive > 0 ? (
         <AnimatedMargin
            marginTop={this.state.open ? '0px' : '-75px'}
            style={{
              display: 'flex',
              flexDirection: 'row',
              position: 'absolute',
              zIndex: 2,
            }}
          >
            <AnimatedDiv
              opacity={this.state.open ? 1 : 0}
              style={{
                backgroundColor: 'none',
                width: 75,
                height: 75,
              }}
              onClick={this.onBack}
            >
              <Image src={backImage} />
            </AnimatedDiv>
            <AnimatedDiv
              opacity={this.state.displayText ? 1 : 0}
              style={{
                animationDelay: '300s',
                display: this.state.display ? 'flex' : 'none',
              }}
              onClick={this.onBack}
            >
              <Image src={backText} style={{ width: 154, height: 70, marginTop: 5, marginLeft: -10 }} />
            </AnimatedDiv>
          </AnimatedMargin>
        ) : null}
        <AnimatedMargin
          marginTop={
            this.state.open
              ? this.props.currentActive > 0
                ? '75px'
                : '0px'
              : this.props.currentActive > 0
                ? '-75px'
                : '-75px'
          }
          style={{
            display: 'flex',
            flexDirection: 'row',
            position: 'absolute',
            zIndex: 2,
          }}
        >
          <AnimatedDiv
            opacity={this.state.open ? 1 : 0}
            style={{
              backgroundColor: 'none', width: 75, height: 75,
            }}
            onClick={this.onCancel}
          >
            <Image src={cancelImage} />
          </AnimatedDiv>
          <AnimatedDiv
            opacity={this.state.displayText ? 1 : 0}
            style={{
              animationDelay: '300s',
              display: this.state.display ? 'flex' : 'none',
            }}
            onClick={this.onCancel}
          >
            <Image src={cancelText} style={{ width: 279, height: 70, marginTop: 5, marginLeft: -10 }} />
          </AnimatedDiv>
        </AnimatedMargin>
      </div>
    );
  }
}

const Image = styled.img`
	display: block;
	height: auto;
  width: 100%;
`;

const AnimatedDiv = styled.div`
  transition: all 300ms ease-in-out;
  opacity: ${props => props.opacity};
`;

const AnimatedMargin = styled.div`
  transition: all 300ms ease-in-out;
  margin-top: ${props => props.marginTop};
`;



// WEBPACK FOOTER //
// ./client/redesign/signup/Main/Navbar/LeftMenuButton/index.js